import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/industries/fintech/page.tsx");
